<script>
import { addGlobalUncaughtErrorHandler } from 'qiankun'
import { defaultMircoApp, microAppsMixin } from '@/config/microApps.config'

export default {
  name: 'Index',
  data () {
    return {
      count: 0
    }
  },
  mixins: [microAppsMixin],
  mounted () {
    this.loadMicroApp(defaultMircoApp)
    addGlobalUncaughtErrorHandler((event) => {
      const { reason, type } = event

      ++this.count

      if (this.count >= 3 && type === 'unhandledrejection' && reason && reason.message === 'Failed to fetch') {
        history.pushState('', '', '500')
      }
    })
  },
  destroyed () {
    this.unmountMircoApp(defaultMircoApp)
  },
  render: (h) => h('div', { domProps: { id: `${defaultMircoApp}-view-box` } })
}
</script>
